module.exports = __webpack_public_path__ + "img/nochooseup.522e8c8e.svg";